/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Editors_Same_Days_NoteInputs */

const en_us2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The same ${i?.count} workouts, on other days. It applies from next week.`)
};

const pt_br2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os mesmos ${i?.count} treinos, em outros dias. Vale a partir da semana que vem.`)
};

const es_419_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los mismos ${i?.count} entrenamientos, en otros días. Se aplica desde la próxima semana.`)
};

const pt_pt2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os mesmos ${i?.count} treinos, noutros dias. Aplica-se a partir da próxima semana.`)
};

const fr_fr2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les mêmes ${i?.count} séances, d'autres jours. Ça s'applique à partir de la semaine prochaine.`)
};

const de_de2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieselben ${i?.count} Trainings, an anderen Tagen. Gilt ab nächster Woche.`)
};

const it_it2_profile_editors_same_days_note = /** @type {(inputs: Profile_Editors_Same_Days_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gli stessi ${i?.count} allenamenti, in altri giorni. Vale dalla prossima settimana.`)
};

/**
* | output |
* | --- |
* | "The same {count} workouts, on other days. It applies from next week." |
*
* @param {Profile_Editors_Same_Days_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_days_note = /** @type {((inputs: Profile_Editors_Same_Days_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_Days_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_days_note(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_days_note(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_days_note(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_days_note(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_days_note(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_days_note(inputs)
	return en_us2_profile_editors_same_days_note(inputs)
});
export { profile_editors_same_days_note as "profile-editors.same_days_note" }